import { render, staticRenderFns } from "./AdformMedia.vue?vue&type=template&id=efdad898&scoped=true&"
import script from "./AdformMedia.vue?vue&type=script&lang=ts&"
export * from "./AdformMedia.vue?vue&type=script&lang=ts&"
import style0 from "./AdformMedia.vue?vue&type=style&index=0&id=efdad898&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efdad898",
  null
  
)

export default component.exports